import {createRouter, createWebHistory} from 'vue-router';
import {authGuard} from './guards/authGuard';
import {canGoGuard} from './guards/canGoGuard';
import {featureToggleGuard} from './guards/featureToggleGuard';
import {permissionGuard} from './guards/permissionGuard';
import {resumeDownloadGuard} from './guards/resumeDownloadGuard';
import {returnRouteGuard} from './guards/returnRouteGuard';
import {subscriptionFeatureGuard} from './guards/subscriptionFeatureGuard';
import {routes} from '../configs/router/routes';
import useAppcues from '@/composables/useAppcues';
import useHotjar from '@/composables/useHotjar';
import useSidebarToggle from '@/composables/useSidebarToggle';

export const onNavigationComplete = (): void => {
  const {triggerHotjarIdentify} = useHotjar();
  const {closeMobileSidebar} = useSidebarToggle();
  const {trackAppcuesPage} = useAppcues();

  triggerHotjarIdentify();
  closeMobileSidebar();
  trackAppcuesPage();
};

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(authGuard);
router.beforeEach(permissionGuard);
router.beforeEach(canGoGuard);
router.beforeEach(featureToggleGuard);
router.beforeEach(subscriptionFeatureGuard);
router.beforeEach((to, from) => returnRouteGuard(to, from, (name) => router.hasRoute(name)));
router.beforeEach(resumeDownloadGuard);

router.afterEach(onNavigationComplete);
